import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography, Box ,  TextField as MuiTextField} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getCurrentDateTime, getMonthYear, request, toast } from '../../../../../utils';
import axios from 'axios';

const PRODUCT_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.product?.main?.name
  }
];

const PRODUCT_DETAILS_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.productDetails?.productInfo?.main?.name
  },
  {
    header: 'Exp Date',
    accessor: (row) => getMonthYear(row?.exp_date)
  },
  {
    header: 'Batch',
    accessor: (row) => row?.productDetails?.batch_no
  },
  {
    header: 'Current Stock',
    accessor: (row) => row?.productDetails?.totalQuantity
  },
];

export const ProductDetails = () => {
  const [productStockDetail, setProductStockDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [stock, setStock] = useState([]);
  const [stockDetails, setStockDetails] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalStocks, setTotalStocks] = useState(0);
  const [input,setInput] = useState('')

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });

  const { handleSubmit, reset, setValue } = methods;
  const getProductDetails = useCallback(async () => {
    const productData = await dropdownFetch('stock-master-details');
    const fromDate = methods.getValues('from_date');
    const toDate = methods.getValues('to_date');
    const filteredData = filterData(productData, fromDate, toDate);
    const flattenedProductDetails = filteredData.flatMap((item) => item.productDetails || []);
    setProductStockDetails(flattenedProductDetails);
  }, [methods]);


  useEffect(() => {
    getProductDetails();
  }, [methods.watch('from_date'), methods.watch('to_date'), getProductDetails]);

  const handleRowClick = (row) => {
    fetchStock(row.product?._id);
  };

  const fetchStock = async (rowId) => {
    try {
      const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);
      if (response?.data?.success) {
        const totalQuantity = response.data.data;
        const totalQuantitySum = totalQuantity.reduce(
          (sum, item) => sum + (item.productDetails?.totalQuantity || 0),
          0
        );
        setStock(totalQuantity);
        setTotalStocks(totalQuantitySum);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setStock({ loading: false, data: [] });
      }
    } catch (error) {
      toast('Error fetching stock data', { variant: 'error' });
      setStock({ loading: false, data: [] });
    }
  };
  

  const handleRowProduct = (row) => {
    if (stock.data && stock.data.length > 0) {
      const allProductDetails = stock.data.flatMap((dataItem) => dataItem.productDetails || []);
      const matchingProducts = allProductDetails.filter((product) => product.product === row.product);
      if (matchingProducts.length > 0) {
        setStockDetails(matchingProducts);
        console.log('Matching Stock Details', matchingProducts);
      } else {
        setStockDetails([]);
      }
    } else {
      setStockDetails([]);
    }
  };

  const filterData = (data, fromDate, toDate) => {
    let filteredData = [...data];
    if (fromDate && toDate) {
      const from = new Date(fromDate).setHours(0, 0, 0, 0);
      const to = new Date(toDate).setHours(23, 59, 59, 999);
      filteredData = filteredData.filter((item) => {
        const createdAt = new Date(item.createdAt).getTime();
        return createdAt >= from && createdAt <= to;
      });
    }
    return filteredData;
  };

  useEffect(() => {
    if (productDetails && productDetails.length > 0) {
      const products = productDetails[0]?.productDetails || [];
      const total = products.reduce((acc, product) => {
        return acc + (product.total_qty || 0) + (product.free_qty || 0);
      }, 0);
      setTotalQuantity(total);
    } else {
      setTotalQuantity(0);
    }
  }, [productDetails]);

  useEffect(() => {
    console.log('HELLLLO PRODUCT STOCK DETAILS', productStockDetail);
  }, [productStockDetail]);
  

  const handleChange =(e)=>{
    setInput(e.target.value)
  }

  useEffect(()=>{
    handleSearchProduct()
  },[input])


  const handleSearchProduct = async () => {
    const lowercaseInput = input.toLowerCase();
    setProductStockDetails({ loading: true, data: [] });

    try {
      const response = await axios.get(
        `${BASE_URL}/stock-master-details/dropdown?name=${lowercaseInput}`
      );

      if (response?.data?.success) {
        const rawDataArray = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

        const filteredData = filterData(rawDataArray); 

        const flattenedProductDetails = Array.isArray(filteredData)
          ? filteredData.flatMap((item) => item.productDetails || [])
          : [];

        setProductStockDetails({ loading: false, data: flattenedProductDetails });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setProductStockDetails({ loading: false, data: [] });
      }
    } catch (error) {
      toast('Error fetching stock data', { variant: 'error' });
      setProductStockDetails({ loading: false, data: [] });
    }
  };

  



  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700, fontSize: '1.4rem' }}>
                Product Details
              </Typography>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid container spacing={2}>
                  {/* First Table */}
                  <Grid
                    item
                    xs={4}
                    sx={{ display: 'flex', flexDirection: 'column', marginLeft: '0.2%', marginTop: '1%' }}
                  >
                    <MuiTextField
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          padding: '0',
                          fontSize: '1.4rem' // Adjust input font size
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '8px 1.4rem'
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '1.2rem' // Adjust label font size
                        }
                      }}
                      label="Search Product"
                      variant="outlined"
                      value={input}
                      onChange={handleChange}
                    />
                    <Table
                      containerSX={{
                        flex: 1,
                        border: '0px solid rgba(0,0,0,0.27)',
                        maxHeight: '500px' 
                      }}
                      data={productStockDetail?.data || []}
                      columns={PRODUCT_HEADER}
                      size="large" 
                      onRowClick={handleRowClick}
                      sx={{
                        '& .MuiTableCell-root': {
                          fontSize: '1.4rem' 
                        },
                        '& .MuiTableCell-head': {
                          fontSize: '1.4rem'
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={7.8} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography color="primary" variant="h6" sx={{ fontWeight: 700, fontSize: '1.4rem' }}>
                       Current Stock :- {totalStocks}
                    </Typography>
                    <Table
                      containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                      data={Array.isArray(stock) ? stock : []} // Ensure stock is an array
                      columns={PRODUCT_DETAILS_HEADER}
                      size="small"
                      onRowClick={(row) => {
                        handleRowProduct(row);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
